import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-myplan',
  templateUrl: './myplan.component.html',
  styleUrls: ['./myplan.component.css']
})
export class MyplanComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
